import _asyncToGenerator from "/vercel/path1/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/asyncToGenerator.js";
var __jsx = React.createElement;
import _regeneratorRuntime from "/vercel/path1/node_modules/next/dist/compiled/@babel/runtime/regenerator/index.js";
import React, { useContext, useState } from "react";
import Modal from "../common/Modal";
import AwesomeIcon from "../AwesomeIcon";
import { faPhone } from "@fortawesome/pro-regular-svg-icons";
import Button from "../common/Button";
import { useTranslation } from "react-i18next";
import TextInput from "../FormComponents/TextInput";
import { useAddITPOCNumber, useAddQurePOCNumber } from "./services";
import { GatewayContext } from "./GatewayContext";
import Toast from "../Toast";
import { get, truncate } from "lodash";
import { mobNumberRegex } from "../../utils/regexValidation";
import copy from "copy-to-clipboard";
import { isIOSWebView } from "../../utils";
function POCModal(_ref) {
  var _selectedGateway$qure2, _selectedGateway$qure4, _selectedGateway$gate, _selectedGateway$qure6, _selectedGateway$qure7, _selectedGateway$qure8;
  var isPOCModalVisible = _ref.isPOCModalVisible,
    setIsPOCModalVisible = _ref.setIsPOCModalVisible,
    selectedGateway = _ref.selectedGateway;
  var _useTranslation = useTranslation(),
    t = _useTranslation.t;
  var _useState = useState(false),
    isEditable = _useState[0],
    setIsEditable = _useState[1];
  var _useState2 = useState(""),
    ITNumber = _useState2[0],
    setITNumber = _useState2[1];
  var _useState3 = useState(""),
    qureNumber = _useState3[0],
    setQureNumber = _useState3[1];
  var _useContext = useContext(GatewayContext),
    refetchGatewayData = _useContext.refetchGatewayData;
  var addQurePOC = useAddQurePOCNumber();
  var addITPOC = useAddITPOCNumber();
  var onCloseModal = function onCloseModal() {
    if (isEditable) {
      setIsEditable(false);
    } else {
      setIsPOCModalVisible(false);
    }
  };
  var handleSave = /*#__PURE__*/function () {
    var _ref2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
      var _selectedGateway$qure, _get;
      return _regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              _context.prev = 0;
              if (!((selectedGateway === null || selectedGateway === void 0 ? void 0 : selectedGateway.gateway_poc_phone) !== ITNumber && ITNumber)) {
                _context.next = 4;
                break;
              }
              _context.next = 4;
              return addITPOC.mutateAsync({
                phone: ITNumber,
                gateway_id: selectedGateway === null || selectedGateway === void 0 ? void 0 : selectedGateway.uuid
              }).then(function () {
                refetchGatewayData();
                setITNumber("");
              });
            case 4:
              if (!((selectedGateway === null || selectedGateway === void 0 || (_selectedGateway$qure = selectedGateway.qure_poc) === null || _selectedGateway$qure === void 0 ? void 0 : _selectedGateway$qure.phone) !== qureNumber && qureNumber && selectedGateway !== null && selectedGateway !== void 0 && selectedGateway.isFirstGateway)) {
                _context.next = 7;
                break;
              }
              _context.next = 7;
              return addQurePOC.mutateAsync({
                phone: qureNumber
              }).then(function () {
                selectedGateway === null || selectedGateway === void 0 ? void 0 : selectedGateway.refetchQurePOC();
                setQureNumber("");
              });
            case 7:
              Toast.success(t("poc.toast.updated"));
              setIsEditable(false);
              setIsPOCModalVisible(false);
              _context.next = 19;
              break;
            case 12:
              _context.prev = 12;
              _context.t0 = _context["catch"](0);
              setQureNumber("");
              setITNumber("");
              setIsEditable(false);
              setIsPOCModalVisible(false);
              Toast.error((_get = get(_context.t0, ["response", "data", "message"], "")) !== null && _get !== void 0 ? _get : t("rule.toast.saved_failed"));
            case 19:
            case "end":
              return _context.stop();
          }
        }
      }, _callee, null, [[0, 12]]);
    }));
    return function handleSave() {
      return _ref2.apply(this, arguments);
    };
  }();
  var onCopy = function onCopy(text) {
    var copytext = text;
    copy(copytext, {
      format: "text/plain",
      onCopy: function onCopy() {
        if (isIOSWebView()) {
          Toast.success(t("poc.toast.copied"));
        }
      }
    });
  };
  return /*#__PURE__*/React.createElement(Modal, {
    title: "Contacts for \n      ".concat(truncate(selectedGateway === null || selectedGateway === void 0 ? void 0 : selectedGateway.gateway_name, {
      length: 20
    })),
    onClose: onCloseModal,
    show: isPOCModalVisible,
    bgOpacity: true,
    titleClassName: "!text-base",
    className: "flex flex-col w-full text-left sm:w-7/12 !bg-gray-100 dark:!bg-gray-800 lg:w-6/12 xl:w-4/12 overflow-hidden"
  }, !isEditable ? /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("div", {
    className: "p-4 pt-5 pb-6 space-y-4"
  }, /*#__PURE__*/React.createElement("div", {
    className: "border border-gray-700 p-5 rounded-lg flex items-center justify-between text-gray-800 dark:text-gray-200"
  }, /*#__PURE__*/React.createElement("p", null, "IT team"), selectedGateway !== null && selectedGateway !== void 0 && selectedGateway.gateway_poc_phone ? /*#__PURE__*/React.createElement("p", {
    className: "text-teal-400 dark:text-teal-300"
  }, /*#__PURE__*/React.createElement(AwesomeIcon, {
    name: faPhone,
    size: "sm"
  }), " ", /*#__PURE__*/React.createElement("button", {
    onClick: function onClick() {
      onCopy(selectedGateway === null || selectedGateway === void 0 ? void 0 : selectedGateway.gateway_poc_phone);
    }
  }, /*#__PURE__*/React.createElement("span", {
    className: "pl-3 focus:outline-none"
  }, selectedGateway === null || selectedGateway === void 0 ? void 0 : selectedGateway.gateway_poc_phone))) : /*#__PURE__*/React.createElement("p", {
    className: "text-gray-500"
  }, "(", t("add_contact"), ")")), /*#__PURE__*/React.createElement("div", {
    className: "border border-gray-700 p-5 rounded-lg flex items-center justify-between text-gray-800 dark:text-gray-200"
  }, /*#__PURE__*/React.createElement("p", null, "Qure.ai"), selectedGateway !== null && selectedGateway !== void 0 && (_selectedGateway$qure2 = selectedGateway.qure_poc) !== null && _selectedGateway$qure2 !== void 0 && _selectedGateway$qure2.phone ? /*#__PURE__*/React.createElement("p", {
    className: "text-teal-400 dark:text-teal-300"
  }, /*#__PURE__*/React.createElement(AwesomeIcon, {
    name: faPhone,
    size: "sm"
  }), " ", /*#__PURE__*/React.createElement("button", {
    onClick: function onClick() {
      var _selectedGateway$qure3;
      onCopy(selectedGateway === null || selectedGateway === void 0 || (_selectedGateway$qure3 = selectedGateway.qure_poc) === null || _selectedGateway$qure3 === void 0 ? void 0 : _selectedGateway$qure3.phone);
    }
  }, /*#__PURE__*/React.createElement("span", {
    className: "pl-3 focus:outline-none"
  }, selectedGateway === null || selectedGateway === void 0 || (_selectedGateway$qure4 = selectedGateway.qure_poc) === null || _selectedGateway$qure4 === void 0 ? void 0 : _selectedGateway$qure4.phone))) : /*#__PURE__*/React.createElement("p", {
    className: "text-gray-500"
  }, "(", t("add_contact"), ")"))), /*#__PURE__*/React.createElement("div", {
    className: "border-t bg-transparent border-gray-500/50 p-5"
  }, /*#__PURE__*/React.createElement(Button, {
    isPrimary: false,
    onClick: function onClick() {
      var _selectedGateway$qure5;
      setIsEditable(true);
      setITNumber(selectedGateway === null || selectedGateway === void 0 ? void 0 : selectedGateway.gateway_poc_phone);
      setQureNumber(selectedGateway === null || selectedGateway === void 0 || (_selectedGateway$qure5 = selectedGateway.qure_poc) === null || _selectedGateway$qure5 === void 0 ? void 0 : _selectedGateway$qure5.phone);
    },
    className: "sm:mt-0 grow-1 w-full !py-5 sm:!py-4 sm:w-fit space-x-2 focus:outline-none"
  }, t("edit_contact_details")))) : /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("div", {
    className: "p-4 pt-5 pb-6 space-y-4"
  }, /*#__PURE__*/React.createElement("div", {
    className: "border border-gray-700 p-5 rounded-lg flex items-center justify-between text-gray-800 dark:text-gray-200"
  }, /*#__PURE__*/React.createElement("p", null, "IT team"), /*#__PURE__*/React.createElement(TextInput, {
    type: "text",
    name: "ITNumber",
    placeholder: "+000000000000",
    defaultValue: (_selectedGateway$gate = selectedGateway === null || selectedGateway === void 0 ? void 0 : selectedGateway.gateway_poc_phone) !== null && _selectedGateway$gate !== void 0 ? _selectedGateway$gate : ITNumber,
    onChange: function onChange(val) {
      setITNumber(val);
    },
    maxLength: 15,
    wrapperClassName: "w-auto group !p-0",
    isClinicalField: true,
    className: "!bg-transparent border-none",
    inputClassName: "text-base bg-transparent !text-gray-700 dark:!text-gray-300 !p-0 !border-gray-500",
    readOnly: false
  })), /*#__PURE__*/React.createElement("div", {
    className: "border border-gray-700 p-5 rounded-lg flex items-center justify-between text-gray-800 dark:text-gray-200"
  }, /*#__PURE__*/React.createElement("p", null, "Qure.ai"), /*#__PURE__*/React.createElement(TextInput, {
    type: "text",
    name: "QureNumber",
    placeholder: "+000000000000",
    defaultValue: (_selectedGateway$qure6 = selectedGateway === null || selectedGateway === void 0 || (_selectedGateway$qure7 = selectedGateway.qure_poc) === null || _selectedGateway$qure7 === void 0 ? void 0 : _selectedGateway$qure7.phone) !== null && _selectedGateway$qure6 !== void 0 ? _selectedGateway$qure6 : qureNumber,
    onChange: function onChange(val) {
      setQureNumber(val);
    },
    disabled: !(selectedGateway !== null && selectedGateway !== void 0 && selectedGateway.isFirstGateway),
    maxLength: 15,
    wrapperClassName: "w-auto group !p-0",
    isClinicalField: true,
    className: "!bg-transparent border-none",
    inputClassName: "text-base !text-gray-700 dark:!text-gray-300 !p-0 bg-transparent !border-gray-500",
    readOnly: false
  }))), /*#__PURE__*/React.createElement("div", {
    className: "border-t flex space-x-3 bg-transparent border-gray-500/50 p-5"
  }, /*#__PURE__*/React.createElement(Button, {
    isPrimary: false,
    onClick: function onClick() {
      setIsEditable(false);
    },
    className: "sm:mt-0 grow-1 w-full !py-5 sm:!py-4 sm:w-fit space-x-2 focus:outline-none"
  }, t("button.cancel")), /*#__PURE__*/React.createElement(Button, {
    isPrimary: true,
    onClick: handleSave,
    disabled: qureNumber === (selectedGateway === null || selectedGateway === void 0 || (_selectedGateway$qure8 = selectedGateway.qure_poc) === null || _selectedGateway$qure8 === void 0 ? void 0 : _selectedGateway$qure8.phone) && ITNumber === (selectedGateway === null || selectedGateway === void 0 ? void 0 : selectedGateway.gateway_poc_phone) || !mobNumberRegex(qureNumber) || !mobNumberRegex(ITNumber),
    className: "sm:mt-0 grow-1 w-full !py-5 sm:!py-4 sm:w-fit space-x-2 focus:outline-none"
  }, t("button.save_close")))));
}
export default POCModal;